import React from "react";

export default class CardiacArrest extends React.Component {
  render() {
    return (
      <>
        <h3>FIRST STEP - ASSESS SAFETY</h3>
        <p>- If nothing is threatening you, come over to the victim. </p>
        <h3>STEP TWO - CHECK VICTIM'S REACTION</h3>
        <p>- Lighlty shake the shoulders</p>
        <p>- Ask loudly: "Is everything alright?" </p>
        <h3>IS REACTING?</h3>
        <p>
          YES - Leave the victim in the same position that you found, unless
          there is any danger.
        </p>
        <p>
          NO - Turn the victim on the back, and clean the breathing paths, by
          moving back the head and moving up the jaw.
        </p>
        <h3>STEP THREE - CHECK LIFE FUNCTIONS</h3>
        <p>
          - Remaining clear breathing paths, for 10 seconds check breathing with
          three methods at the same time:
        </p>
        <p>- Assess with your eyes any chest movements </p>
        <p>- Listen near the victim's lips for any breathing whispering </p>
        <p>- Try to sense air movement on your chick </p>
        <h3>IS BREATHING?</h3>
        <p>
          YES - Put the victim in the safety position, send someone for help or
          ask for it yourself (call ambulance), regularly assess breathing.
        </p>
        <p>
          NO - Send someone for help, and if you are alone, leave the victim and
          call for ambulance, return and begin pressing chest according to the
          following step.
        </p>
        <h3>STEP FOUR – RKO 1 – RESCUE PRESSURES</h3>
        <p>- Kneel next to the victim </p>
        <p>- Put wrist of one hand on the chest of the victim </p>
        <p>- Put the second hand's wrist on the first one. </p>
        <p>
          - Join the fingers of both hands and ensure, that you will not be
          pressuring the victim's ribs; don't pressure the upper stomach nor the
          lower end of the sternum.
        </p>
        <p>
          - Get down over the victim, straight arms set perpendicularly to the
          sternum and pressure aprox. 5-6cm deep.
        </p>
        <p>
          - After each pres release chest pressure, without removing the hands
          from the sternum. Repeat pressures with a rate not slower then 100/min
          and not more than 120/min (aprox 2 pressures/s, the rythm of "Staying
          Alive").
        </p>
        <p>
          - The period of pressuring and releasing pressure (releaxation) of the
          sternum should be the same.
        </p>
        <p>- After doing 30 pressures move to the step five. </p>
        <h3>STEP FIVE – RKO 2 – RESCUE BREATHS</h3>
        <p>
          - After doing 30 chest pressures, clean the airpaths by holding back
          the head and raising up the jaw.
        </p>
        <p>
          - Close the nostrils using a pointing finger and a thumb of the hand
          put on the vitctim's forehead.
        </p>
        <p>
          - Leave lips slightly open, at the same time continuing to raise up
          the jaw.
        </p>
        <p>
          - Take a normal breath and seal tightly vitctim's lips with your lips,
          making sure, that there is no air leak.
        </p>
        <p>
          - Slowly breath in air into victim's mouth for around 1 second (as
          with normal breathing) observing at the same time if the chest is
          rising (only such rescue breath is effective).
        </p>
        <p>
          - Keeping holding back the head and raising up the jaw, remove your
          lips from the victim's lips and observe if during the breath out the
          chest is falling down.
        </p>
        <p>
          - Once again get air and blow in the victim's mouth, going for
          performing two effective rescure breaths; next again hold hands in the
          correct position on the sternum and do 30 more chest pressures.
        </p>
        <p>
          - Continue pressuring chest and doing rescue breaths in ratio 30:2
        </p>
        <p>
          - Stop your actions to check on the victim's state only, if you see
          correct breathing. In any other case do not stop rescuscitating.
        </p>
        <p>
          - If the first rescue breath doesn't cause chest moving up as with
          normal breathing, do as following:
        </p>
        <p>- Check the mouth of the victim and remove any alien objects. </p>
        <p>
          - Check, if holding back the head and moving up the jaw is done
          correctly.
        </p>
        <p>
          - Do no more then 2 attempts of ventilation every time, before
          returning to pressuring the chest. If on the place of the event is
          more than one rescuer, rescuers should change while performing
          reanimation every 1-2 minutes, to prevent fatigue, and every change
          should be accompanied by again checking up on life functions. it's
          important to keep breaks from rescuscitation down to the minimum.
        </p>
        <h3>STEP SIX - WHEN TO STOP?</h3>
        <p>
          - When qualified medical service arrives and takes over the
          intervention.
        </p>
        <p>- When the victim starts breathing correctly. </p>
        <p>- When you get exhausted. </p>
        <p>- When somebody changes you in doing the rescue activities. </p>
        <p>- When something or someone starts to threaten your security.</p>
      </>
    );
  }
}
